import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import Logo from "./Logo";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-line bg-deep-surface mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <Logo size="lg" linked={false} />
            <p className="text-xs text-zinc-500 mt-4 font-mono leading-relaxed max-w-xs">
              {t.footer.tagline}
            </p>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-neon-violet font-mono mb-3">{t.footer.legalTitle}</div>
            <ul className="space-y-2 text-xs text-zinc-400">
              <li><Link to="/privacy" className="hover:text-neon-cyan transition" data-testid="footer-privacy">{t.footer.privacy}</Link></li>
              <li><Link to="/cookies" className="hover:text-neon-cyan transition" data-testid="footer-cookies">{t.footer.cookies}</Link></li>
              <li><Link to="/terms" className="hover:text-neon-cyan transition" data-testid="footer-terms">{t.footer.terms}</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-neon-violet font-mono mb-3">{t.footer.companyTitle}</div>
            <div className="text-xs text-zinc-400 leading-relaxed">
              <div className="font-semibold text-zinc-200" data-testid="footer-makai-line">FoodGo è un prodotto Renova360 by Makai</div>
              <div className="font-mono mt-1">P.IVA 09936410969</div>
            </div>
          </div>
        </div>

        <div className="neon-divider mb-6" />

        <div className="flex items-center justify-between flex-wrap gap-4 text-[11px] text-zinc-500 font-mono">
          <div className="uppercase tracking-widest">{t.landing.footer}</div>
          <Link
            to="/sa-login"
            className="text-[10px] tracking-[0.3em] text-zinc-600 hover:text-neon-yellow transition border border-line rounded-md px-2 py-1"
            data-testid="footer-sa-link"
            title="Super Admin"
          >
            SA
          </Link>
        </div>
      </div>
    </footer>
  );
}
